export default "__VITE_PUBLIC_ASSET__86032ca8__"